import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewCapacity extends React.Component {
  
  render() {
    const capacity = this.props.reservation.capacity;
    const errors = this.props.errors;

    return (
      <td>
        <SMFormTextField
          name="capacity"
          value={capacity ? capacity : null}
          options={{className: 'w110'}}
          placeholderText="10"
          delegate={this}
        /> 人
        <span
          className="message-important ml10">{SMFormatHelper.errorText('Reservation', 'use_type', errors)}</span>
      </td>
    );
  }
}

SMReservationEditViewCapacity.propTypes = {
  reservation: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
};
export default SMReservationEditViewCapacity;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewCapacity.jsx